<section class="relative overflow-hidden">
  <!-- Container -->
  <div class="max-w-screen-xl mx-auto">
    <div class="lg:columns-2 lg:gap-8">
      <!-- Content -->
      <div
        class="relative bg-slate-50 py-16 px-5 sm:py-24 sm:px-6 lg:col-span-6 lg:rounded-br-[64px] lg:px-8 lg:pt-32 2xl:pl-0">
        <!-- Background to cover left portion of large screens -->
        <div
          class="absolute inset-y-0 hidden w-full -left-full bg-slate-50 lg:block"></div>

        <div class="relative max-w-2xl mx-auto lg:mx-0 lg:max-w-none">
          <h2
            class="font-display text-4xl font-semibold leading-tight text-slate-900 sm:text-5xl sm:leading-tight lg:text-[40px] lg:leading-tight xl:text-5xl xl:leading-tight">
            {{ 'PAGE.CONTACT.TITLE' | translate }}
            <span class="ml-4 sm:ml-6">👋</span>
          </h2>

          <div class="mt-12 aspect-w-3 aspect-h-2 sm:mt-16">
            <img
              class="object-cover w-full h-full rounded-3xl xl:left-16"
              src="/assets/img/contact.jpg" />
          </div>
        </div>
      </div>

      <!-- Contact form container -->
      <div
        class="px-5 py-16 sm:py-24 sm:px-6 lg:col-span-6 lg:pl-0 lg:pr-8 lg:pt-32 xl:col-span-5 xl:col-start-8 2xl:pr-0">
        <div class="max-w-lg mx-auto lg:mr-0">
          <!-- Contact form -->
          <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="mt-10">
            <div class="space-y-7">
              <div>
                <label
                  class="block font-medium leading-6 text-md text-slate-900"
                  for="first-name">
                  {{ 'COMMON.FIRST_NAME' | translate }}
                </label>
                <div class="mt-2">
                  <input
                    [class.disabled:bg-gray-50]="isDisabled"
                    [class.disabled:cursor-not-allowed]="isDisabled"
                    [class.disabled:ring-gray-200]="isDisabled"
                    [class.disabled:text-gray-800]="isDisabled"
                    [class.ring-red-300]="isInvalidControl('lastName')"
                    [class.text-red-900]="isInvalidControl('lastName')"
                    [placeholder]="
                      'PAGE.CONTACT.FORM.PLACEHOLDER.LAST_NAME' | translate
                    "
                    autocomplete="given-name"
                    class="block w-full px-4 py-4 leading-4 transition-colors duration-200 ease-in-out border-0 shadow-sm rounded-xl bg-slate-50 text-md text-slate-900 shadow-sky-100/50 ring-1 ring-inset ring-slate-200 placeholder:text-slate-400 hover:bg-white focus:border-0 focus:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-600/60"
                    formControlName="lastName"
                    id="last-name"
                    name="last-name"
                    type="text" />
                </div>
                <p
                  *ngIf="isInvalidControl('lastName')"
                  class="mt-2 text-sm text-red-500">
                  {{ 'PAGE.CONTACT.FORM.ERROR.LAST_NAME' | translate }}
                </p>
              </div>
              <div>
                <label
                  class="block font-medium leading-6 text-md text-slate-900"
                  for="last-name">
                  {{ 'COMMON.LAST_NAME' | translate }}
                </label>
                <div class="mt-2">
                  <input
                    [class.disabled:bg-gray-50]="isDisabled"
                    [class.disabled:cursor-not-allowed]="isDisabled"
                    [class.disabled:ring-gray-200]="isDisabled"
                    [class.disabled:text-gray-800]="isDisabled"
                    [class.ring-red-300]="isInvalidControl('firstName')"
                    [class.text-red-900]="isInvalidControl('firstName')"
                    [placeholder]="
                      'PAGE.CONTACT.FORM.PLACEHOLDER.FIRST_NAME' | translate
                    "
                    autocomplete="family-name"
                    class="block w-full px-4 py-4 leading-4 transition-colors duration-200 ease-in-out border-0 shadow-sm rounded-xl bg-slate-50 text-md text-slate-900 shadow-sky-100/50 ring-1 ring-inset ring-slate-200 placeholder:text-slate-400 hover:bg-white focus:border-0 focus:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-600/60"
                    formControlName="firstName"
                    id="first-name"
                    name="first-name"
                    type="text" />
                </div>
                <p
                  *ngIf="isInvalidControl('firstName')"
                  class="mt-2 text-sm text-red-500">
                  {{ 'PAGE.CONTACT.FORM.ERROR.FIRST_NAME' | translate }}
                </p>
              </div>
              <div>
                <label
                  class="block font-medium leading-6 text-md text-slate-900"
                  for="email">
                  {{ 'COMMON.EMAIL' | translate }}
                </label>
                <div class="mt-2">
                  <input
                    [class.disabled:bg-gray-50]="isDisabled"
                    [class.disabled:cursor-not-allowed]="isDisabled"
                    [class.disabled:ring-gray-200]="isDisabled"
                    [class.disabled:text-gray-500]="isDisabled"
                    [class.ring-red-300]="isInvalidControl('email')"
                    [class.text-red-900]="isInvalidControl('email')"
                    [placeholder]="
                      'PAGE.CONTACT.FORM.PLACEHOLDER.EMAIL' | translate
                    "
                    autocomplete="email"
                    class="block w-full px-4 py-4 leading-4 transition-colors duration-200 ease-in-out border-0 shadow-sm rounded-xl bg-slate-50 text-md text-slate-900 shadow-sky-100/50 ring-1 ring-inset ring-slate-200 placeholder:text-slate-400 hover:bg-white focus:border-0 focus:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-600/60"
                    formControlName="email"
                    id="email"
                    name="email"
                    type="email" />
                </div>
                <p
                  *ngIf="isInvalidControl('email')"
                  class="mt-2 text-sm text-red-500">
                  {{ 'PAGE.CONTACT.FORM.ERROR.EMAIL' | translate }}
                </p>
              </div>
              <div>
                <div class="flex justify-between leading-6 text-md">
                  <label class="block font-medium text-slate-900" for="message">
                    {{ 'COMMON.MESSAGE' | translate }}
                  </label>
                </div>
                <div class="mt-2">
                  <textarea
                    [class.disabled:bg-gray-50]="isDisabled"
                    [class.disabled:cursor-not-allowed]="isDisabled"
                    [class.disabled:ring-gray-200]="isDisabled"
                    [class.disabled:text-gray-500]="isDisabled"
                    [class.ring-red-300]="isInvalidControl('message')"
                    [class.text-red-900]="isInvalidControl('message')"
                    [placeholder]="
                      'PAGE.CONTACT.FORM.PLACEHOLDER.MESSAGE' | translate
                    "
                    class="block w-full px-4 py-4 leading-6 transition-colors duration-200 ease-in-out border-0 shadow-sm rounded-xl bg-slate-50 text-md text-slate-900 shadow-sky-100/50 ring-1 ring-inset ring-slate-200 placeholder:text-slate-400 hover:bg-white focus:border-0 focus:bg-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sky-600/60"
                    formControlName="message"
                    id="message"
                    name="message"
                    rows="5"></textarea>
                </div>
                <p
                  *ngIf="isInvalidControl('message')"
                  class="mt-2 text-sm text-red-500">
                  {{ 'PAGE.CONTACT.FORM.ERROR.MESSAGE' | translate }}
                </p>
              </div>
            </div>
            <div class="pt-8 mt-10 border-t border-slate-200">
              <button
                [class.disabled:cursor-not-allowed]="isDisabled"
                [class.disabled:opacity-75]="isDisabled"
                [disabled]="isDisabled"
                class="inline-flex items-center rounded-full gap-2.5 justify-center px-7 py-3 font-semibold leading-none outline-offset-2 transition-all duration-200 ease-in-out active:transition-none bg-slate-900 text-white hover:bg-sky-800 w-full text-base sm:text-lg"
                id="submit"
                type="submit">
                {{ 'COMMON.SEND' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<div *ngIf="isOpen" class="absolute z-50" role="dialog">
  <div
    @opacity
    class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div
      class="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
      <div
        @open
        class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
        <div>
          <div
            class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
            <svg
              aria-hidden="true"
              class="h-6 w-6 text-primary-600"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              viewBox="0 0 24 24">
              <path
                d="M4.5 12.75l6 6 9-13.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div class="mt-3 text-center sm:mt-5">
            <h3
              class="text-base font-semibold leading-6 text-king-blue"
              id="modal-title">
              {{ 'PAGE.CONTACT.MODAL.TITLE' | translate }}
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-800">
                {{ 'PAGE.CONTACT.MODAL.INTRO' | translate }}
              </p>
            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <button
              (click)="onCloseModal()"
              class="inline-flex w-full justify-center rounded bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
              id="modal-close"
              type="button">
              {{ 'COMMON.CLOSE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
